import { subsidyGrants } from "../../config/homePageUtils";
import Section from "./Section";

const SubsidyGrantsSection = ({ language }) => {
  return (
    <Section
      id="subsidy-grants-section"
      title={language ? "अनुदान और सहायता" : "Subsidy and Grants"}
      spaceY4Needed={false}
    >
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-2">
        {subsidyGrants.map((category, idx) => (
          <div
            key={idx}
            className="bg-white border-t-2 border-[#018f9b] shadow-md p-8 rounded-lg min-h-[300px]"
          >
            <h3 className="text-xl font-semibold text-[#018f9b] mb-4">
              {language ? category.category.hi : category.category.en}
            </h3>

            <div className="space-y-3 text-sm leading-relaxed">
              {category.items.map((item, i) => (
                <div key={i} className="flex items-start gap-2">
                  <span className="text-green-600 pt-1">✔</span>
                  <p>
                    {item.label && (
                      <b>{language ? item.label.hi : item.label.en} </b>
                    )}
                    {language ? item.description.hi : item.description.en}
                  </p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default SubsidyGrantsSection;
